import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bold'
})
export class BoldPipe implements PipeTransform {

  transform(value: string, boldSubString: string|string[]): string {
    if (Array.isArray(boldSubString)) {
      let formatedValue = value
      boldSubString.forEach((str)=>{
        formatedValue = formatedValue.replace(str, ` <br><b>${str}</b>`)
      })      
      return formatedValue
    }
    return value;
  }

}
